import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartComponent } from './cart/cart.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { NgForm, FormsModule } from '@angular/forms';
import { AuthGuardService } from '../guards/auth-guard.service';
import { CheckoutService } from '../guards/checkout.service';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [CartComponent, CheckoutComponent],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule, 
    SharedModule,
    SimpleNotificationsModule.forRoot({
      position:["middle","center"],
       timeOut: 3000,
       showProgressBar: true,
       pauseOnHover: true,
       clickToClose: true
     }),
    RouterModule.forChild([
      {path: 'checkout', component: CheckoutComponent, canActivate: [AuthGuardService,CheckoutService]},
      {path: 'cart', component: CartComponent,canActivate: [AuthGuardService]}
    ])
  ]
})
export class ShoppingModule { }
